import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@features/auth/auth.service'

export const nonAuthenticatedGuard = () => {
  if (!inject(AuthService).authenticated) {
    return true
  }

  return inject(Router).createUrlTree(['/'])
}
